import { getRecruitList, updateRecruitStatus, delRecruitById } from '@/api/home/recruit'

export class RecruitController {
  static async page (params: HOME.RECRUIT_PARAMS) {
    const { code, data } = await getRecruitList(params)
    return {
      data: data.records,
      sum: data.total
    }
  }
}
